import axios from 'axios'

const http = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL
})
const HEADERS = {
    'Content-Type': 'application/json'
};

export async function postResendPassword(email, dispatch) {
    dispatch({ type: 'OPEN_LOADING' })
    await http.post('/account/resend',
        {
            "email": email,
            "type": "password"
        },
        {
            headers: HEADERS
        }).then(response => {
            successResendPassword(response, dispatch);
        }).catch(erro => {
            erroResendPassword(erro.response, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};

function successResendPassword(response, dispatch) {
    if (response.status === 200) {
        dispatch({
            type: 'OPEN_ALERT_DIALOG',
            title: 'Recuperação de Senha',
            description: 'Enviamos um e-mail com instruções para redefinir a senha'
        })
    }
}

function erroResendPassword(erro, dispatch) {
    if (erro.status === 400) {
        dispatch({
            type: 'OPEN_ALERT_DIALOG',
            title: 'Recuperação de Senha',
            description: 'E-mail invalido ou não cadastrado'
        })
    }
}
